//селекторы
export const cardContainerSelector = '.cards__list';// селектор контейнер карточек в разметке
export const selectorProfileName = '.profile__name';//селектор с именем профиля
export const selectorProfileDesc = '.profile__desc';//селектор с описанием профиля
export const selectorCardTemplate = '.cards-template';//селектор разметки карточки
export const selectorPopupProfileEdit = '.popup_type_edit';//селектор попапа редактирования профиля
export const selectorPopupAddCard = '.popup_type_new-card';//селектор попапа редактирования профиля
export const selectorPopupWithImage = '.popup_type_image';//селектор попапа с изображением
export const selectorPopupDelete = '.popup_type_delete'; //селектор попапа с подтверждением удаления
export const selectorPopupEditAvatar = '.popup_type_edit-avatar'; // селектор попапа редактирования фото профиля
export const selectorFormAddCard = '.form_type_add'; //селектор формы добавления карточки
export const selectorFormEdit = '.form_type_edit';// селектор формы редактирования
export const selectorFormEditAvatar = '.form_type_edit-avatar';// селектор формы редактирования фото профиля
export const selectorAvatarProfile = '.profile__image'//селектор изображения профиля

export const ERROR_LOGIN = 'Пользователь с таким email еще не зарегистрирован';

export const ERROR_REGISTER = 'Пользователь с таким email уже зарегистрирован';

export const ERROR_EMAIL_FORMAT = "Введите e-mail в формате: ivanov@yandex.ru";

export const SUCCESS_REGISTER = 'Вы успешно зарегистрировались!';

export const BASE_URL = 'https://api-mesto-tat-rs.vercel.app';